import React, { useRef } from 'react'
import Sidebar from 'blocks.app/sidebar/sidebar'
import Icon from 'blocks.simple/icon/icon'
import Button from 'blocks.simple/button/button'
import translate from 'core/translate'
import { colors, text as textStyles } from 'theme'
import { grid } from 'theme'
import { api } from 'core/api/ConnectionManager'
import { cn } from 'ethcss'
import { draftDevicesActions } from '../draftDevice.state'
import { useDispatch } from 'react-redux'
import { AddDeviceCurrentLicense } from 'pages/displays/organisms/AddDeviceByCode/AddDeviceByCode-types'
import { MenuItem } from '../../displays/__toolbarContent/displays__toolbarContent'
import { SidebarMultiselectMenu } from '../../../blocks.app/sidebarMultiselectMenu/SidebarMultiselectMenu'
import styles from './styles.jcss'

interface IDraftDevicesToolbarProps {
    selectedInfo: {
        id: number
        name: string
        status: string
    } | null
    selectedItems: { id: number }[]
    onChange: (selectedItems: { id: number }[]) => void
    setOpenRegisterModal: (value: boolean) => void
    openRegisterModal: boolean
    currentLicense: AddDeviceCurrentLicense
}

const DraftDevicesToolbar = (p_: IDraftDevicesToolbarProps) => {
    const deleteItemRef = useRef<any>(null)
    const dispatch = useDispatch()
    const openInformationModal = () => {
        const options: any = {
            modalState: 'information',
        }
        dispatch(draftDevicesActions.openModal(options))
    }

    const openRegisterModal = () => {
        p_.setOpenRegisterModal(true)
    }

    const color: { [index: string]: string } = { offline: 'offline', error: 'error', online: 'online' }

    return (
        <Sidebar
            selectedSide={'right'}
            onChange={(list: any) => p_.onChange(list)}
            customContent={{
                right:
                    p_.selectedItems.length === 0 && p_.selectedInfo ? (
                        <div className={cn(grid.full, grid.colCenter)}>
                            <div className={cn(textStyles.up, grid.pb_md)}>{p_.selectedInfo.name}</div>
                            <div className={styles.iconWrapper}>
                                <Icon
                                    type={'noBroadcast'}
                                    size={'70%'}
                                    color={color[p_.selectedInfo.status]}
                                    containerClass={cn(grid.colCenter)}
                                />
                                <img className={styles.noLicense} src={'images/displays/license_is_blocked.svg'} />
                                <div
                                    className={styles.menuPanel}
                                    onClick={() => {
                                        deleteItemRef.current()
                                    }}
                                >
                                    <Icon
                                        type={'delete'}
                                        size={16}
                                        color={colors.white}
                                        containerClass={cn(grid.colCenter)}
                                        tooltip={{
                                            title: translate('delete'),
                                        }}
                                    />
                                </div>
                            </div>

                            <div className={grid.mt_md}>
                                <Button onClick={openInformationModal}>{translate('information')}</Button>
                            </div>
                            <div>
                                <Button onClick={openRegisterModal}>{translate('register')}</Button>
                            </div>
                        </div>
                    ) : (
                        <div />
                    ),
            }}
            content={{
                right:
                    !p_.selectedInfo && p_.selectedItems.length
                        ? {
                              title: `${translate('countOfSelectedDevices')}: ${
                                  p_.selectedItems ? p_.selectedItems.length : ''
                              }`,
                              options: p_.selectedItems,
                          }
                        : null,
            }}
            topContent={{
                right: (
                    <SidebarMultiselectMenu>
                        <MenuItem data={{ name: 'register' }} onClick={openRegisterModal} />
                        <MenuItem
                            data={{ name: 'delete' }}
                            onClick={() => {
                                deleteItemRef.current()
                            }}
                        />
                    </SidebarMultiselectMenu>
                ),
            }}
            isEmpty={{
                right: !p_.selectedInfo && p_.selectedItems.length === 0,
            }}
            emptyText={{
                right: {
                    title: (
                        <div className={cn(textStyles.normalPlus, textStyles.up)}>{translate('noDisplayInfo')} </div>
                    ),
                    description: translate('selectDraftDeviceDescription'),
                },
            }}
            onSubmit={(side: string, type: string) => {
                if (side === 'right' && type === 'delete') {
                    const ids: any = []

                    if (p_.selectedItems.length) {
                        p_.selectedItems.forEach((item) => {
                            ids.push(item.id)
                        })
                    }
                    if (p_.selectedInfo) {
                        ids.push(p_.selectedInfo.id)
                    }

                    if (ids.length) {
                        api.send('deleteDisplay', { id: ids })
                    }
                }
            }}
            deleteItemRef={deleteItemRef}
        />
    )
}

export default DraftDevicesToolbar
